<template>
	<el-dialog
		title="扫描验证"
		:visible.sync="errorwin"
		width="30%"
		:modal-append-to-body="false"
		lock-scroll
		:show-close="false"
		:close-on-click-modal="false"
	>
		<div class="errorwin">
			<div class="errormsg">
				<span>{{ errormsg }}</span>
			</div>
			<div class="tips">请扫描下方条码或者在输入框中填写 1A 再回车</div>
			<div><el-input v-model="errorcode" ref="errorcode" @keyup.enter.native="EnterEvent('errorcode')"></el-input></div>
			<div class="barcode"><img src="../../static/system_01/image/tmA.png" /></div>
		</div>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	data() {
		return {
			errorwin:false,
			errormsg:'',
			errorcode:'',
			isread:false,
			isgo:false,
			focuscontrol:''
		};
	},
	methods: {
		init(param){
			var that=this;
			this.errorwin=true;
			this.errorcode='';
			if(param.errormsg!=undefined)
				this.errormsg=param.errormsg;
			if(param.isread!=undefined) //是否读语音报错
				this.isread=param.isread;
			if(param.isgo!=undefined)
				this.isgo=param.isgo;
			if(param.focuscontrol!=undefined)
				this.focuscontrol=param.focuscontrol;
			this.$nextTick(function() {
				that.$refs.errorcode.focus();
			});
			if(this.isread&&this.errormsg!=''){
				this.$tool.ReadMsg(this.errormsg);
			}
		},
		EnterEvent(control) {
			if(control=='errorcode')
			{
				if(this.errorcode.toLocaleLowerCase() == '1a')
					this.closewin();
				else
				{
					this.errorcode='';
					if(this.isread){
						this.$tool.ReadMsg('请扫描下方条码');
					}
				}
			}
		},
		closewin(){
			this.errorwin=false;
			this.$emit('closeerrorwin', {isgo:this.isgo,focuscontrol:this.focuscontrol});
		}
	},
}
</script>

<style>
</style>
